import ApiClient, { ReqOptions } from './ApiClient';
import { Upload } from './types';

export const del = {
	uploadById: async (id: string, opts?: ReqOptions): Promise<Upload> => {
		const client = await ApiClient.getInstance();
		return client.remove('/uploads', id, opts);
	},
};
